import { Controller } from "@hotwired/stimulus"
import {enter, leave} from "tailwindcss-stimulus-components/src/transition"

// Connects to data-controller="search-filter"
export default class extends Controller {
  static targets = ["searchForm"]

  toggle() {
    if (!this.hasSearchFormTarget) return

    if (this.isOpen) {
      leave(this.searchFormTarget)
    } else {
      enter(this.searchFormTarget)
    }
  }

  get isOpen() {
    return !this.searchFormTarget.classList.contains("hidden")
  }
}
